import { useContext } from "react";

import { AnalyticsContext, AnalyticsEvent } from "providers/AnalyticsProvider";

export { AnalyticsEvent };

export default function useAnalytics() {
  const analyticsContext = useContext(AnalyticsContext);

  return analyticsContext;
}
